import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionTriageNextV3Request } from './get-collection-triage-next-v3-request';
import type { IGetCollectionTriageNextV3Response } from './get-collection-triage-next-v3-response';
import { getCollectionTriageNextV3ResponseSchema } from './get-collection-triage-next-v3-response';

export async function getCollectionTriageNextV3Api({
  collectionId,
}: IGetCollectionTriageNextV3Request): Promise<
  IValidatedResponse<IGetCollectionTriageNextV3Response>
> {
  return getRequest<IGetCollectionTriageNextV3Response>({
    path: `/sys/collections/${collectionId}/triage/next/v3`,
    schema: getCollectionTriageNextV3ResponseSchema,
  });
}
